import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=414d134c&scoped=true&"
import script from "./CardBase.vue?vue&type=script&lang=js&"
export * from "./CardBase.vue?vue&type=script&lang=js&"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=414d134c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d134c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
